import React from 'react'
import PropTypes from 'prop-types';
import { rules, FormField, FormComponent } from 'Common/components/Form'
import { Button, UsersSearch } from 'Common/components';
import { loader } from 'graphql.macro';
import { message, Row, Col, Modal } from 'antd';
import { withApollo } from '@apollo/client/react/hoc';
import { __error } from 'Common/scripts/consoleHelper';

const UPDATE_SHARED = loader('src/Graphql/Todos/updateTodoShared.graphql');


const TodoSharedForm = ({ onSuccess, onCancel, client, initialValues }) => {
       
    const onSubmit = async (values) => {
        const input = {
            _id: Number(initialValues._id),
            shared_with: values.shared_with && values?.shared_with?.map(o=>({ _id:o._id, name:o.name })),
        }

        let results = await client.mutate({ mutation: UPDATE_SHARED, variables: { input } }).then(r => (r?.data?.updateTodoShared))
            .catch(err => {
                console.log(__error("ERROR: "), err);
                return { error: { message: "Failed to process the request!" } }
            })


        if (results.error){
            message.error(results.error.message);
            return false;
        }

        onSuccess();
        return false;
    }

    return (<>
        <FormComponent onSubmit={onSubmit} id='TodoSharedForm' fields={initialValues} debug={false} 
            mutators={{
                selectUser: (newValueArray, state, tools) => {
                    let node = newValueArray[0];

                    let _dataArray = state.formState.values.shared_with || [];
                    _dataArray.push({ _id: node._id, name: node.name })

                    tools.changeValue(state, 'shared_with', () => _dataArray);
                },
                de_selectUser: (newValueArray, state, tools) => {
                    let _dataArray = state.formState.values.shared_with || [];
                    let _ids = state.formState.values.shared_with_ids || [];

                    _dataArray = _dataArray.filter(o => (_ids.includes(o._id)))

                    tools.changeValue(state, 'shared_with', () => _dataArray)
                },
            }}
            form_render={formProps => {
                const { values, submitting, form, invalid, dirty, valid } = formProps;

                return (<>
                    <UsersSearch mode="multiple" label="shared_with" name='shared_with_ids'
                        filter={{ status:"enabled" }}
                        preload disableSearch
                        onSelect={(___, opt, raw) => form.mutators.selectUser(raw)}
                        onDeselect={(txt, node) => form.mutators.de_selectUser(node)}
                        defaultValues={values.shared_with ? values.shared_with.map(o => ({ ...o, title: o.name })) : []}
                        validate={rules.required}
                    />
                    
                    <Row gutter={[10]}>
                        <Col flex="auto" />
                        <Col><Button onClick={onCancel} color="white">Cancel</Button></Col>
                        <Col><Button type="primary" size="medium" block htmlType='submit' loading={submitting} disabled={!dirty || !valid} >{values._id ? "Update" : "Create"} Ticket</Button></Col>
                    </Row>                    

                </>)
            }}
        />

    </>)
}
const WithApollo = withApollo(TodoSharedForm)

export default function TodoSharedFormModal({ initialValues, visible, onCancel, onSuccess }) {
    const handel_onSuccess = (values) => {
        if (onSuccess) onSuccess()
        else onCancel()
    }

    let shared_with_ids = initialValues && initialValues?.shared_with?.map(o=>(o._id));

    return (<>
        <Modal title="Sahred With" visible={visible} width="700px" onCancel={onCancel} footer={false} closable centered destroyOnClose>
            {visible && <WithApollo onCancel={onCancel} initialValues={{ ...initialValues, shared_with_ids }} onSuccess={handel_onSuccess} />}
        </Modal>
    </>)
}
TodoSharedFormModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    initialValues: PropTypes.object,
}

